import React, { useMemo, useState } from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import { ExportModal } from "./ExportModal";
import { useCombinedFilters } from "../../../hooks/useCombinedFilters";
import {
  useExportDisabledMessage,
  useExportVisibility,
} from "../../../hooks/useExportVisibility";

export const ExportButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const combinedFilters = useCombinedFilters();
  const canExport = useExportVisibility();
  const exportDisabledMessage = useExportDisabledMessage();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const isFiltersApplied = useMemo(() => {
    return Object.keys(combinedFilters || {}).length > 0;
  }, [combinedFilters]);

  const isExportDisabled = !isFiltersApplied || !canExport;
  const exportTooltipTitle = !canExport
    ? exportDisabledMessage
    : !isFiltersApplied
      ? "Apply filters to enable export"
      : "";

  return (
    <>
      <Tooltip title={exportTooltipTitle}>
        <span>
          <Button
            variant="text"
            color="secondary"
            disabled={isExportDisabled}
            sx={{
              height: "100%",
              borderRadius: 0,
            }}
            onClick={handleOpenModal}
            startIcon={<DownloadIcon />}
          >
            EXPORT
          </Button>
        </span>
      </Tooltip>
      {isModalOpen && <ExportModal onClose={handleCloseModal} />}
    </>
  );
};
